<template>
  <ui-confirmation-modal visible>
    <template #title>
      {{ $i18nPresenter.t('Cannot upload image') }}
    </template>

    <template #body>
      <div class="text-center">
        {{ $i18nPresenter.t('There might have been a network issue. Please try again!') }}
      </div>
    </template>

    <template #footer>
      <ui-button variant="primary" @click="$emit('handleOkButtonClick')">
        {{ $i18nPresenter.t('OK') }}
      </ui-button>
    </template>
  </ui-confirmation-modal>
</template>

<script>
import ConfirmationModal from '@/components/UI/modals/ConfirmationModal.vue'
import Button from '@/components/UI/Button.vue'

export default {
  components: {
    UiButton: Button,
    UiConfirmationModal: ConfirmationModal,
  },
}
</script>
